import React, { useState, useEffect } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import Icon from '../../components/Icon/Icon';

const ThemeChooserSuccess = ({theme}) => {
  const [isOpen, setOpenState] = useState(false);

  useEffect(() => {
    window.hasChosenTheme = null;
    setOpenState(true);
    setTimeout(setOpenState, 5000, false);
  }, []);
  return (
    <div
      className={
        isOpen
          ? 'theme-chooser-success theme-chooser-success--open'
          : 'theme-chooser-success theme-chooser-success--close'
      }
    >
      <div className={`theme_chooser-icon theme_chooser-icon--${theme}`}>
        <Icon type="check"/>
      </div>
      <p className="theme-chooser-subtitle">
        <FormattedHTMLMessage
          tagName="span"
          id="theme_chooser.subtitle"
          defaultMessage="You always can change theme in&nbsp;the settings of&nbsp;your profile"
        />
      </p>
      <Button type="button" color="primary" onClick={() => setOpenState(false)}>
        <FormattedMessage id="main.ok" defaultMessage="OK" />
      </Button>
    </div>
  );
};

export default ThemeChooserSuccess;
